/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align */

import {ProjectElement}         from './project.element';
import {ProjectElementType}     from './project.element.type';
import {Project}                from '../project';
import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";

/**
 *
 * @class RootElement
 *
 * @brief placeholder for the very top of any project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
@ProjectElementFactoryDecorator('RootElement')
export class RootElement extends ProjectElement {

  /** standard constructor */
  constructor(
    project: Project,
         id: string,
       name: string,
       icon: string
  ) {

    super(project, id, ProjectElementType.Root);

    this._expanded = true;
    this._enabled  = true;
    this._label    = name;
    this._icon     = icon;
  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring RootElement");
  }

}
